export const loadPage = () => {
  document.body.classList.add("loaded");
};
